import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./Layout.scss";

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  const isHomePage = pathname === "/";

  return (
    <>
      <Navbar />

      <main className={`main-layout ${isHomePage ? "main-layout--home" : ""}`}>
        {children}
      </main>

      <Footer />
    </>
  );
};

export default Layout;
